
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.profile-menu{
  display:flex;
  flex-direction:column;
  position:relative;
}

.profile-menu--nav{
  display:flex;
  width:100%;
  transition:transform 0.3s ease-in-out, height 0.3s ease-in-out;
  z-index:2;
}

.profile-menu--nav.mobile{
    position:absolute;
    top:100%;
  }

.profile-menu--nav.mobile.open{
      animation:openAnim 0.5s ease-in-out;
    }

.profile-menu--nav.mobile.closed{
      height:0;
      animation:closeAnim 0.5s ease-in-out;
    }

.profile-menu--nav.mobile.hidden{
      display:none;
    }

@keyframes closeAnim{
  0%{
    display:flex;
    height:295px;
  }
  99%{
    height:0px;
  }
  100%{
    display:none;
  }
}

@keyframes openAnim{
  0%{
    display:none;
    height:0;
  }
  1%{
    display:flex;
    height:0;
  }
  100%{
    height:295px;
  }
}

.profile-menu--list{
  list-style:none;
  margin:0;
  padding:0;
  width:100%;
}

.profile-menu--link{
  display:flex;
  padding:1rem 1.5rem;
  text-decoration:none;
  color:var(--brand-neutral-white);
  font-size:var(--fs-xl);
}

.profile-menu--link.mobile{
    color:var(--gray-800);
    font-size:var(--fs-base);
    font-weight:var(--fw-medium);
  }

.profile-menu--link.mobile:focus,
    .profile-menu--link.mobile:hover{
      background-color:var(--brand-neutral-gray-200) !important;
    }

.profile-menu--link.active span{
      border-bottom:2px solid var(--gray-800);
      color:var(--gray-800);
    }

.profile-menu--link.active:focus,
    .profile-menu--link.active:hover{
      background-color:var(--green-300);
    }

.profile-menu--link:focus,
  .profile-menu--link:hover{
    cursor:pointer;
    background-color:var(--brand-primary-2);
  }

.profile-menu--link:focus{
    outline-style:solid;
    outline-offset:0;
    outline-width:4px;
  }

.profile-menu--item{
  background-color:var(--brand-primary-1);
}

.profile-menu--item.mobile{
    background-color:var(--brand-neutral-gray-100);
  }

.profile-menu--item.active-item{
    background-color:var(--green-200);
  }
`;